import React from 'react'

const FrontendReady = () => <h1 style={{ textAlign: 'center' }}>Frontend Ready</h1>

export default FrontendReady
